import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=53afee84&scoped=true"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"
import style0 from "./Publish.vue?vue&type=style&index=0&id=53afee84&prod&lang=css"
import style1 from "./Publish.vue?vue&type=style&index=1&id=53afee84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afee84",
  null
  
)

export default component.exports